import type { NTable } from '../interface';

export function findAllChildrenKeys<RecordType>(
  data: readonly RecordType[],
  getRowKey: NTable.NRow.TGetRowKey<RecordType>,
  childrenColumnName: string
): NTable.TKey[] {
  const keys: NTable.TKey[] = [];

  function dig(list: readonly RecordType[]) {
    (list || []).forEach((item, index) => {
      keys.push(getRowKey(item, index));

      dig((item as any)[childrenColumnName]);
    });
  }

  dig(data);

  return keys;
}
